import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import './AddEmployeeProject.css';
import { API_URL } from './API';

const UpdateEmployeeProject = ({ project, employee, onClose, onEmployeeUpdated }) => {
  const [formData, setFormData] = useState({
    assignmentId: '',
    employeeId: '',
    employeeName: '',
    role: '',
    location: '',
    phoneNumber: '',
    assignedBy: '',
    assignmentDate: '',
    endingDate: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (employee) {
      const formatDateForInput = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      setFormData({
        assignmentId: employee.assignmentId || employee.id || '',
        employeeId: employee.employee_id || employee.id || '',
        employeeName: employee.employee_name || employee.name || '',
        role: employee.role || '',
        location: employee.location || '',
        phoneNumber: employee.phone_number || employee.phone || '',
        assignedBy: employee.assigned_by || employee.assignedBy || '',
        assignmentDate: formatDateForInput(employee.assignment_date || employee.assignmentDate),
        endingDate: formatDateForInput(employee.ending_date || employee.endingDate)
      });
    }
  }, [employee]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    if (loading) {
   
      return;
    }
    
    if (!formData.employeeId || !formData.employeeName || !formData.role || !formData.location) {
      alert('Please fill in all required fields');
      return;
    }

    if (!formData.assignmentId) {
      alert('Assignment ID is missing. Cannot update employee.');
      return;
    }

    try {
      setLoading(true);
      
      const payload = {
        id: formData.assignmentId,
        employee_id: formData.employeeId,
        project_id: project.id,
        employee_name: formData.employeeName,
        role: formData.role,
        location: formData.location,
        phone_number: formData.phoneNumber || '',
        assigned_by: formData.assignedBy || '',
        assignment_date: formData.assignmentDate || '',
        ending_date: formData.endingDate || ''
      };

      const response = await fetch(`${API_URL}/projects/update_employee_to_project`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      

      const data = await response.json();
    

      if (!response.ok) {
        throw new Error(data.message || `Failed to update: ${response.status}`);
      }

      alert('Employee updated successfully!');
      
      if (onEmployeeUpdated) {
        onEmployeeUpdated();
      }
      
      onClose();
      
    } catch (error) {
      
      
      if (error.message === 'Failed to fetch') {
        alert(`Cannot connect to server. Please check:
1. Backend is running on ${API_URL}
2. CORS is enabled on backend
3. Network connectivity`);
      } else {
        alert(error.message || 'Failed to update employee. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="AEEP-00">
      <div className="AEEP-01">
        <div className="AEEP-02">
          <div>
            <h2>Update Employee Project</h2>
            <p className="AEEP-03">Project: {project?.project_name || 'Unknown Project'}</p>
          </div>
          <FaTimes className="AEEP-04" onClick={onClose} />
        </div>

        <div className="AEEP-05">
          <div style={{ padding: '20px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  Employee ID *
                </label>
                <input
                  type="text"
                  name="employeeId"
                  value={formData.employeeId}
                  onChange={handleChange}
                  disabled
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  Employee Name *
                </label>
                <input
                  type="text"
                  name="employeeName"
                  value={formData.employeeName}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  Role *
                </label>
                <input
                  type="text"
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  Location *
                </label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  Phone Number
                </label>
                <input
                  type="text"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  Assigned By
                </label>
                <input
                  type="text"
                  name="assignedBy"
                  value={formData.assignedBy}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  Assignment Date
                </label>
                <input
                  type="date"
                  name="assignmentDate"
                  value={formData.assignmentDate}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  Ending Date
                </label>
                <input
                  type="date"
                  name="endingDate"
                  value={formData.endingDate}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }}
                />
              </div>
            </div>

            <div style={{ marginTop: '30px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                style={{
                  padding: '10px 20px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  backgroundColor: '#fff',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '4px',
                  backgroundColor: '#007bff',
                  color: '#fff',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1
                }}
              >
                {loading ? 'Updating...' : 'Update Employee'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateEmployeeProject;